// extracted by css-extract-rspack-plugin
export default {"dropdown":"hGV3a","item":"eGlL9","itemSection":"FAB_5","label":"ELR5s","divider":"seIl1"};